<template>
  <div class="positions">
    <player-profile-dialog
      v-if="showProfileUser"
      :user="showProfileUser"
      :game="game"
      :visible="true"
      :closeAction="function() {showProfileUser=null}"
    />
    <v-data-table
      :class="'positionTable ' + ($vuetify.breakpoint.smAndDown ? 'positionTableSmall' : '')"
      :loading="loading"
      :headers="responsiveHeaders"
      :items="league.positions"
      @click:row="onRowClicked"
      hide-default-footer
      :disable-sort="true"
      sort-by="position"
      :items-per-page="1000"
      mobile-breakpoint="290"
    >
      <template v-if="displayGamesPlayedColumn == false" v-slot:top>
        <v-container class="pa-0" v-if="displayGamesPlayedColumn == false">
          <v-row>
            <v-col class="pt-0 pb-0" align="right">
              <help-icon :text="$t('positions.rotate-notice')" />
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template
        v-slot:header.score="{ header }"
      >{{ (displayShortScoreHeader ? 'Pkt' : header.text) }}</template>
      <template v-slot:item.image="{ item }">
        <v-img
            v-if="item.club_image"
            :src="item.club_image"
            :lazy-src="item.club_image"
            contain
            height="30"
            max-width="40"
        ></v-img>
      </template>
      <template v-slot:item.name="{ item }">
          <span :class="`position-${item.position}`">
            <player-or-team-name :player="getPlayerOfPosition(item)"/>
            <award-list :awards="item.awards" />
          </span>
      </template>
      <!--
            <template v-slot:item.trend="{ item }">
                <v-icon :color="trendColor(item.trend)">{{ trendIcon(item.trend) }}</v-icon>
                {{item.trend}}
            </template>
      -->
      <template v-slot:item.scored="{ item }">
        <span class="text-no-wrap">
          <span class="primary--text">{{item.goals}}</span>
          :
          <span class="warning--text">{{item.opponent_goals}}</span>
        </span>
      </template>
    </v-data-table>
    <v-container class="pa-0">
      <v-row>
        <v-col class="pt-0 pb-0">
          <award-legend :awards="allAwards" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  EVENT_GAME_RESULT_ADDED,
  EVENT_REFRESH_DATA
} from "@/plugins/eventbus";
import PlayerProfileDialog from "@/widgets/PlayerProfileDialog";
import AwardList from "@/widgets/AwardList";
import AwardLegend from "@/widgets/AwardLegend";
import HelpIcon from "@/widgets/HelpIcon";
import PlayerOrTeamName from './PlayerOrTeamName.vue'

export default {
  name: "Positions",
  components: {
    PlayerProfileDialog,
    AwardList,
    AwardLegend,
    HelpIcon,
    PlayerOrTeamName,
  },
  props: {
    game: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      loading: false,
      showProfileUser: null,
      headers: [
        {
          text: this.$t('positions.headers.position-short'),
          align: "center",
          sortable: true,
          value: "position"
        },
        { text: this.$t('positions.headers.image'), value: "image" },
        { text: this.$t('positions.headers.player'), value: "name" },
        { text: this.$t('positions.headers.goals'), value: "scored" },
        { text: this.$t('positions.headers.score'), value: "score" },
        { text: this.$t('positions.headers.games-played'), value: "games_played" }
      ],
      league: {
        positions: []
      }
    };
  },
  computed: {
    displayShortScoreHeader() {
      return this.$vuetify.breakpoint.width <= 360;
    },
    displayGamesPlayedColumn() {
      return this.$vuetify.breakpoint.width > 400; // .name === 'xs'
    },
    responsiveHeaders() {
      return !this.displayGamesPlayedColumn
        ? this.headers.filter(h => !["games_played"].includes(h.value))
        : this.headers;
    },
    allAwards() {
      var ret = [];
      this.league.positions.forEach(pos => {
        pos.awards.forEach(award => {
          ret.push(award);
        });
      });
      return ret;
    }
  },
  watch: {
    game: function() {
      console.log("game changed");
      this.league.positions = [];
      this.refreshLeagueTable();
    }
  },
  mounted() {
    this.refreshLeagueTable();
    this.$eventBus.$on(EVENT_GAME_RESULT_ADDED, this.onGameResultAddedEvent);
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_GAME_RESULT_ADDED, this.onGameResultAddedEvent);
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  methods: {
    getPlayerOfPosition(item) {
      return {
        name: item.name,
        uid: item.uid,
        verified: item.user_verified
      }
    },
    onRowClicked(row) {
      if (row.type === null) {
        this.showProfileUser = this.getPlayerOfPosition(row)
      } else {
        console.log("TBD", row);
      }
    },
    onGameResultAddedEvent(event) {
      if (event.gameuid == this.game.uid) {
        this.refreshLeagueTable();
      }
    },
    onRefreshData() {
      this.refreshLeagueTable();
    },
    refreshLeagueTable() {
      this.loading = true;
      this.$api
        .getLeagueTable(this.game.uid)
        .then(response => {
          this.loading = false;
          let data = response.data;
          // console.log(data);
          this.league.positions = data;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    trendIcon(trend) {
      if (trend > 0) {
        return "mdi-arrow-top-right";
      } else if (trend < 0) {
        return "mdi-arrow-bottom-right";
      } else {
        return "mdi-arrow-right";
      }
    },

    trendColor(trend) {
      if (trend > 0) {
        return "primary";
      } else if (trend < 0) {
        return "warning";
      } else {
        return "grey";
      }
    }
  }
};
</script>

<style scoped>
.positionTableSmall >>> thead.v-data-table-header tr th:first-child {
  padding-right: 0;
}
.positionTableSmall >>> tbody tr td:first-child {
  padding-right: 0;
}
.position-1 {
  color: var(--v-primary-base);
  text-shadow: 0 0 5px var(--v-primary-darken1),
    0 0 10px var(--v-primary-darken1), 0 0 15px var(--v-primary-darken1),
    0 0 30px var(--v-primary-darken1), 0 0 35px var(--v-primary-darken1);
}
.position-2 {
  color: var(--v-accent-base);
  text-shadow: 0 0 5px var(--v-accent-base), 0 0 10px var(--v-accent-base),
    0 0 30px var(--v-accent-base),
    0 0 35px var(--v-accent-base);
}
.position-3 {
  color: var(--v-secondary-lighten2);
  text-shadow: 0 0 5px var(--v-secondary-darken1);
}
</style>
